// @flow
import dispatchAsync from 'utils/dispatchAsync';
import type { ZuzuThunk, ReportState, Like, Comment } from 'types';

export type Report = {
  reportId: string,
  title: string,
  description: string,
  image?: string,
  status: ReportState,
  likesCount: number,
  commentsCount: number,
  createdAt: number,
};
export type LoadReportsAction = {
  type: 'LOAD_REPORTS',
  payload?: Array<Report>,
  meta: {
    done: boolean,
    error?: boolean,
  },
};
export const LOAD_REPORTS = 'LOAD_REPORTS';
export const loadReports = (): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: LOAD_REPORTS,
    url: '/api/management/report/all',
    method: 'get',
    dispatch,
    transform: payload => [
      ...payload.sort((a, b) => b.createdAt - a.createdAt),
    ],
  });
};

export const COMMENT = 'COMMENT';
export const comment = (
  reportId: string,
  text: string
): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: COMMENT,
    url: '/api/management/comment',
    method: 'post',
    dispatch,
    body: {
      reportId,
      text,
    },
  });
};

export const EDIT_COMMENT = 'EDIT_COMMENT';
export const editComment = (
  reportId: string,
  commentIndex: number,
  text: string
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: EDIT_COMMENT,
    url: '/api/management/comment',
    method: 'put',
    dispatch,
    body: {
      reportId,
      commentIndex,
      text,
    },
  });

export type StateChange = {
  state: ReportState,
  createdAt: number,
  text: string,
};
export type SingleReport = {
  approvedState: 'mailSent',
  city: string,
  comments: Array<Comment>,
  createdAt: number,
  createdBy: {
    firstname: string,
    lastname: string,
    email: string,
  },
  description: string,
  images: Array<string>,
  likes: Array<Like>,
  reportId: string,
  states: Array<StateChange>,
  status: ReportState,
  street: string,
  title: string,
  zip: string,
};

export type LoadSingleReportAction = {
  type: 'LOAD_SINGLE_REPORT',
  payload?: SingleReport,
  meta: {
    done: boolean,
    error?: boolean,
  },
};
export const LOAD_SINGLE_REPORT = 'LOAD_SINGLE_REPORT';
export const loadSingleReport = (
  reportId: string
): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: LOAD_SINGLE_REPORT,
    url: `/api/management/report/single/${reportId}`,
    method: 'get',
    dispatch,
  });
};

export type DeleteReportAction = {
  type: 'DELETE_REPORT',
  payload: null,
  meta: {
    done: boolean,
    error?: boolean,
  },
};
export const DELETE_REPORT = 'DELETE_REPORT';
export const deleteReport = (
  reportId: string,
  reason: string
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: DELETE_REPORT,
    url: '/api/admin/report/delete',
    method: 'post',
    body: {
      reportId,
      reason,
    },
    dispatch,
  });

export const CHANGE_STATE = 'CHANGE_STATE';
export const changeState = (
  reportId: string,
  state: ReportState,
  reason: string
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: CHANGE_STATE,
    url: '/api/management/report',
    method: 'post',
    body: {
      reportId,
      status: state,
      text: reason,
    },
    dispatch,
  });



// WEBPACK FOOTER //
// ./src/redux/actions/reports.js